import React, { useMemo, useState } from 'react';

/**
 * A pending Choose-a-Block request: raised when a listing primitive (Single /
 * Multiple Listings) is dropped, consumed by the picker modal in the extensions
 * package. Holds the drop position captured at drop time so the block the user
 * picks lands exactly where the primitive would have.
 */
export interface ListingPickerRequest {
  // The primitive block type that opened the picker (for the modal heading).
  type: string;
  // tags$Category name whose saved blocks the picker offers.
  category: string;
  // Where the chosen block should be inserted.
  parentIdx: string;
  positionIndex?: number;
}

export const ListingPickerContext = React.createContext<{
  request: ListingPickerRequest | null;
  open: (req: ListingPickerRequest) => void;
  close: () => void;
}>({
  request: null,
  open: () => {},
  close: () => {},
});

export const ListingPickerProvider: React.FC<{ children?: React.ReactNode }> = props => {
  const [request, setRequest] = useState<ListingPickerRequest | null>(null);

  const value = useMemo(
    () => ({
      request,
      open: (req: ListingPickerRequest) => setRequest(req),
      close: () => setRequest(null),
    }),
    [request],
  );

  return (
    <ListingPickerContext.Provider value={value}>
      {props.children}
    </ListingPickerContext.Provider>
  );
};
